
import {PropType} from 'vue';
import Popper from "vue3-popper";

export default {
    props: {
        position: {
            type: String as PropType<string>,
            default: 'bottom'
        },
        hover: {
            type: Boolean as PropType<boolean>,
            default: false
        },
        offsetDistance: {
            type: String as PropType<string>,
            default: '10'
        },
        zIndex: {
            type: String as PropType<string>,
            default: '9999'
        }
    },
    emits: ['open', 'close'],
    components: {
        Popper
    },
    methods: {
        onOpen() {
            this.$emit('open');
        },
        onClose() {
            this.$emit('close');
        }
    }
}
